const hasElementWithSpecifiedValue = (elements, propertyName, propertyValue) =>
  elements?.some((element) => element[propertyName] === propertyValue);

export const hasName = (elements) =>
  hasElementWithSpecifiedValue(elements, "type", "firstname");
export const hastLastname = (elements) =>
  hasElementWithSpecifiedValue(elements, "type", "lastname");
